import { format } from "date-fns";
import { ru } from "date-fns/locale";

export const getFormattedDateParts = (dateInput: string | Date) => {
    const date = typeof dateInput === "string" ? new Date(dateInput) : dateInput;

    return {
        date: format(date, "d MMMM yyyy", { locale: ru }),
        time: format(date, "HH:mm", { locale: ru })
    };
};